module.exports = __webpack_public_path__ + "img/BUZONMOV.dabe9f16.svg";